import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {Outsourced} from "../Outsourced";
import {NormalWin} from "../runnerpresentations/maingame/win/NormalWin";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {RevealXWays} from "../runnerpresentations/maingame/RevealXWays";
import {FreeSpinsOutro} from "../runnerpresentations/freespin/FreesSpinOutro";
import {BrokeBankPresentation} from "../runnerpresentations/maingame/win/BrokeBankPresentation";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DoXNudge} from "../runnerpresentations/DoXNudge";
import {OutsourcedCrashGameIdlePresentation} from "./OutsourcedCrashGameIdlePresentation";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {FreeSpinsIntro} from "../runnerpresentations/freespin/FreesSpinIntro";
import {WinCountUp} from "../runnerpresentations/maingame/win/WinCountUp";

export class OutsourcedWinPresentation implements FlowStatePresentation {
    private presentations:SimplePresentation[];

    constructor() {
        this.presentations = [
            //new RevealWilds(),
            new DoXNudge(),
            new RevealXWays(),
            new NormalWin(),
            new WinCountUp(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.updateWin(controller),
                () => {
                    //return BrickSnake2000.model.isNonFreespinsOutroMaxWin;
                    return !Outsourced.model.data.brokeTheBank;
                },
                "UpdateWin"),
            //new SanityCheckPresentation()
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.noWinPadding(controller),
                () => {return Outsourced.model.data.mode != GameMode.NORMAL &&
                              Outsourced.model.data.nextMode == GameMode.NORMAL},
                "NoWinPadding"),
            new FreeSpinsIntro(),
            new FreeSpinsOutro(),
            new BrokeBankPresentation(),
        ];
    }

    private noWinPadding(controller:SimplePresentationRunnerController) {
        const isQuickstop = Outsourced.apiPlugin.settings.get(APISetting.FAST_SPIN);
        gsap.timeline().add(() => {}).add(() => controller.finish(), isQuickstop ? '>0.25' : '>0.5');
    }

    public start(flowStateController:FlowStateController) {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "WinRunner ");
    }

    private updateWin(controller:SimplePresentationRunnerController) {
        const winAmount = Outsourced.model.data.accumulatedRoundWin;
        Outsourced.keypadPlugin.setWin(winAmount,
                                       Outsourced.model.data.mode != GameMode.NORMAL ||
                                       Outsourced.model.data.nextMode != GameMode.NORMAL,
                                       Outsourced.isWinBelowStake());
        controller.finish();
    }
}